module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-800-heavy-italic-b2557002b9e85106abb07b3c4801d812.woff";